import { HttpClient } from '@wix/http-client';
import { Addon } from '../../types/addons';
import { getQueryParams } from '../../utils';

const WIX_SERVERLESS_ROUTE_KEY = 'x-wix-route';

const httpClient = new HttpClient({
  baseURL: '/_serverless/editor-platform-addons/',
});

export const getAddons = async (
  searchParams?: URLSearchParams,
): Promise<Addon[]> => {
  const queryParams = getQueryParams();
  const extendedSearchParams = new URLSearchParams(searchParams);

  // this will assure that `serverless deploy preview` works with param being set in the url
  if (queryParams[WIX_SERVERLESS_ROUTE_KEY]) {
    extendedSearchParams.append(
      WIX_SERVERLESS_ROUTE_KEY,
      queryParams[WIX_SERVERLESS_ROUTE_KEY],
    );
  }

  const query = extendedSearchParams
    ? `?${extendedSearchParams.toString()}`
    : '';
  const response = await httpClient.get<Addon[]>(`/${query}`);
  return response.data;
};
